export default __webpack_public_path__ + "static/actuator-from-behind-edb80dadf857d6776089d6a9870c0387.jpeg";